import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Trash2, X } from "lucide-react";

export default function BulkActionBar({
  count,
  adminUsers,
  bulkAssignTo,
  setBulkAssignTo,
  applyBulkAssign,
  statusBerkasField,
  hasilAkhirField,
  applyBulkData,
  applyBulkDelete,
  onClear,
}) {
  return (
    <Card data-testid="bulk-assign-bar" className="bg-[#121212] border-primary/40 p-3 rounded-md fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex flex-wrap items-center gap-3 shadow-2xl max-w-[95vw]">
      <div className="text-sm text-white font-medium whitespace-nowrap">
        <span className="font-mono text-primary">{count}</span> dipilih
      </div>

      {/* Bulk assign */}
      <div className="flex items-center gap-1.5">
        <Select value={bulkAssignTo} onValueChange={setBulkAssignTo}>
          <SelectTrigger data-testid="bulk-assign-select" className="bg-[#0A0A0A] border-border h-9 w-40">
            <SelectValue placeholder="Assign admin..." />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="__unassigned">Unassign</SelectItem>
            {adminUsers.map((a) => (
              <SelectItem key={a.id} value={a.id}>{a.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Button data-testid="apply-bulk-assign" onClick={applyBulkAssign} size="sm" className="bg-primary hover:bg-[#0056B3]">
          Set
        </Button>
      </div>

      {/* Bulk status berkas */}
      {statusBerkasField && (statusBerkasField.options || []).length > 0 && (
        <Select value="" onValueChange={(v) => applyBulkData("status_berkas", v)}>
          <SelectTrigger data-testid="bulk-status-berkas-select" className="bg-[#0A0A0A] border-border h-9 w-44">
            <SelectValue placeholder="Status Berkas..." />
          </SelectTrigger>
          <SelectContent>
            {(statusBerkasField.options || []).map((o) => (
              <SelectItem key={o} value={o}>{o}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}

      {/* Bulk hasil akhir */}
      {hasilAkhirField && (hasilAkhirField.options || []).length > 0 && (
        <Select value="" onValueChange={(v) => applyBulkData("hasil_akhir", v)}>
          <SelectTrigger data-testid="bulk-hasil-akhir-select" className="bg-[#0A0A0A] border-border h-9 w-44">
            <SelectValue placeholder="Hasil Akhir..." />
          </SelectTrigger>
          <SelectContent>
            {(hasilAkhirField.options || []).map((o) => (
              <SelectItem key={o} value={o}>{o}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}

      {/* Bulk delete */}
      <Button
        data-testid="apply-bulk-delete"
        onClick={applyBulkDelete}
        size="sm"
        variant="outline"
        className="border-destructive/40 bg-destructive/10 text-destructive hover:bg-destructive/20"
      >
        <Trash2 className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.5} />
        Hapus
      </Button>

      <Button variant="outline" onClick={onClear} className="border-border bg-transparent" size="sm">
        <X className="w-3.5 h-3.5" strokeWidth={1.5} />
      </Button>
    </Card>
  );
}
